import { Button, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: {
    xs: "80vw",
    sm: "50vw",
    md: "30vw",
  },
  width: {
    xs: "90vw",
    sm: "60vw",
    md: "40vw",
  },
  maxHeight: "90%",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "8px",
  p: { xs: 2, md: 4 },
};

interface AvailabilityFormModalProps {
  open: boolean;
  close: () => void;
  businessId?: number;
  customStyle?: object;
  sx?: object;
}

export default function AvailabilityFormModal({
  open,
  close,
  businessId,
  customStyle = {},
  sx = {},
}: AvailabilityFormModalProps) {
  const navigate = useNavigate();
  return (
    <Modal
      open={open}
      onClose={close}
      aria-labelledby="customer-modal-title"
      aria-describedby="customer-modal-description"
      sx={{ ...sx }}
    >
      <Box sx={{ ...style, ...customStyle }}>
        {/* Modal Title */}
        <Typography sx={{ fontSize: "22px", fontWeight: "600" }}>
          New availabilities have been added to the home page!
        </Typography>

        {/* Modal Body */}
        <Box mt={2}>
          <Typography sx={{ fontSize: "17px", fontWeight: "400" }}>
            Referees and other businesses can now book your items through
            Referee!!
          </Typography>

          <Typography
            style={{
              fontSize: "17px",
              fontFamily: "400",
              lineHeight: "25px",
              color: "#000",
            }}
          >
            Check your{" "}
            <span style={{ fontWeight: "bold" }}>"My Availabilities"</span> list
            to make any changes or updates if needed.
          </Typography>
        </Box>

        {/* Modal Footer */}
        <Box
          mt={2}
          display="flex"
          flexDirection="column"
          justifyContent="flex-end"
          gap={"10px"}
        >
          <Button
            sx={{
              width: "100%",
              backgroundColor: "#2E7D32",
              fontWeight: 600,
              color: "#FFF",
              "&:hover": {
                backgroundColor: "#2E7D32",
              },
            }}
            onClick={() => {
              close();
              navigate(`/availabilities/${businessId}`);
            }}
          >
            My Availabilities
          </Button>

          <Button
            variant="outlined"
            sx={{
              width: "100%",
              borderColor: "#000",
              color: "#000",
              fontWeight: 600,
              "&:hover": {
                borderColor: "#000",
                backgroundColor: "#f5f5f5",
              },
            }}
            onClick={() => {
              close();
              navigate("/home");
            }}
          >
            Home
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}